import { loadStripe } from '@stripe/stripe-js'
import { Stripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import React from 'react'

interface Props {
  children: React.ReactNode
}

export default function PaymentMethodStripeWrapper({ children }: Props) {
  const stripeKeys: Record<string, string> = {
    staging: 'pk_test_51QSNI4IO8znrKeTZhqhkcxw0blJszt4R2wItky3MwXFhZ2BCU1b5icVW2ktBhVe8exuMFPYU9Sr7s3mRsMBINyEU00vsfypbmy',
    dev: 'pk_test_51QG5OnIBFLOCRedmHsgRDt55gklVhd5I2iL0xmukrdWw93fr0lGLD6ClpnzU57ISwOnXNCWmFWxeASG7Cexc4JkX00MM2wnBwd',
    development: 'pk_test_51QSNI4IO8znrKeTZhqhkcxw0blJszt4R2wItky3MwXFhZ2BCU1b5icVW2ktBhVe8exuMFPYU9Sr7s3mRsMBINyEU00vsfypbmy',
    production: 'pk_live_51QG5OnIBFLOCRedmxh46nUVOkKdmUlLKA1bDketitKcgHH6fCzrfw18BWGL3UbHZ6vzQqsD2KMnsUipXRTnLFm22004gPbl6Qc',
  }
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging'
  const stripePK = stripeKeys[env] || stripeKeys.staging
  const stripePromise: Promise<Stripe | null> = loadStripe(stripePK)

  return <Elements stripe={stripePromise}>{children}</Elements>
}
